<template>
  <div class="wrap-main-nav">
    <div class="main-nav">
      <!-- Menu desktop -->
      <nav class="menu-desktop">
        <a class="logo-stick" href="#">
          <img src="images/icons/logo-01.png" alt="LOGO" />
        </a>

        <ul class="main-menu">
          <li class="main-menu-active">
            <a href="/">Home</a>
            <!-- <ul class="sub-menu">
                                <li><a href="index.html">Homepage v1</a></li>
                                <li><a href="home-02.html">Homepage v2</a></li>
                                <li><a href="home-03.html">Homepage v3</a></li>
                            </ul> -->
          </li>

          <li class="mega-menu-item">
            <a href="#">Amakuru</a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#news-all"
                  role="tab"
                  >All</a
                >
                <a
                  class="nav-link"
                  data-toggle="pill"
                  href="#news-entertainment"
                  role="tab"
                  >Imyidagaduro</a
                >
                <a
                  class="nav-link"
                  data-toggle="pill"
                  href="#news-business"
                  role="tab"
                  >Business</a
                >
                <a
                  class="nav-link"
                  data-toggle="pill"
                  href="#news-lifestyle"
                  role="tab"
                  >Ubuzima</a
                >
                <a
                  class="nav-link"
                  data-toggle="pill"
                  href="#news-travel"
                  role="tab"
                  >Ubukerarugendo</a
                >
              </div>

              <div class="tab-content">
                <div class="tab-pane show active" id="news-all" role="tabpanel">
                  <div class="row">
                    <NewsAll
                    v-for="(news,key) in newsAll"
                    :key="key"
                    :category="news.category"
                    :title="news.excerpt"
                    :newsImage="news.image"
                    :dateCreated="news.created_at"
                    :slug="news.slug" />
                  </div>
                </div>

                <div class="tab-pane" id="news-entertainment" role="tabpanel">
                  <div class="row">
                    <NewsEntertainment
                    v-for="(entertainment,key) in entertainments"
                    :key="key"
                    :category="entertainment.category"
                    :dateCreated="entertainment.created_at"
                    :entertainmentImage="entertainment.image"
                    :title="entertainment.excerpt"
                    :slug="entertainment.slug" />
                  </div>
                </div>

                <div class="tab-pane" id="news-business" role="tabpanel">
                  <div class="row">
                    <NewsBusiness
                    v-for="(business,key) in businessess"
                    :key="key"
                    :businessImage="business.image"
                    :category="business.category"
                    :dateCreated="business.created_at"
                    :title="business.excerpt"
                    :slug="business.slug" />
                  </div>
                </div>

                <div class="tab-pane" id="news-lifestyle" role="tabpanel">
                  <div class="row">
                    <NewsUbuzima
                    v-for="(ubuzima, key) in ubuzimas"
                    :key="key"
                    :category="ubuzima.category"
                    :dateCreated="ubuzima.created_at"
                    :lifestyleImage="ubuzima.image"
                    :title="ubuzima.excerpt"
                    :slug="ubuzima.slug" />
                  </div>
                </div>

                <div class="tab-pane" id="news-travel" role="tabpanel">
                  <div class="row">
                    <NewsTravel
                    v-for="(ubukerarugendo, key) in ubukerarugendos"
                    :key="key"
                    :category="ubukerarugendo.category"
                    :dateCreated="ubukerarugendo.created_at"
                    :title="ubukerarugendo.excerpt"
                    :travelImage="ubukerarugendo.image"
                    :slug="ubukerarugendo.slug" />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mega-menu-item">
            <a href="/imyidagaduro-category">Imyidagaduro </a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#imyidagaduro-all"
                  role="tab"
                  >All</a
                >
              </div>

              <div class="tab-content">
                <div class="tab-pane show active" id="imyidagaduro-all" role="tabpanel">
                  <div class="row">
                    <ImyidagaduroAll
                    v-for="(imyidagaduro, key) in entertainments"
                    :key="key"
                    :category="imyidagaduro.category"
                    :dateCreated="imyidagaduro.created_at"
                    :imyidagaduroImg="imyidagaduro.image"
                    :title="imyidagaduro.excerpt"
                    :slug="imyidagaduro.slug" />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mega-menu-item">
            <a href="business-category">Business</a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#business-all"
                  role="tab"
                  >Amakuru ya Bisiness</a
                >
              </div>

              <div class="tab-content">
                <div
                  class="tab-pane show active"
                  id="business-all"
                  role="tabpanel"
                >
                  <div class="row">
                    <BusinessAll
                    v-for="(business, key) in businessess"
                    :key="key"
                    :category="business.category"
                    :dateCreated="business.created_at"
                    :imyidagaduroImg="business.image"
                    :title="business.excerpt"
                    :slug="business.slug" />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mega-menu-item">
            <a href="/ubukerarugendo-category">Ubukerarugendo</a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#ubukerarugendo-all"
                  role="tab"
                  >All</a
                >
              </div>

              <div class="tab-content">
                <div class="tab-pane show active" id="ubukerarugendo-all" role="tabpanel">
                  <div class="row">
                    <UbukerarugendoAll
                    v-for="(ubukerarugendo,key) in ubukerarugendos"
                    :key="key"
                    :businessImage="ubukerarugendo.image"
                    :category="ubukerarugendo.category"
                    :dateCreated="ubukerarugendo.created_at"
                    :title="ubukerarugendo.excerpt"
                    :slug="ubukerarugendo.slug" />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mega-menu-item">
            <a href="/ubuzima-category">Ubuzima</a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#ubuzima-all"
                  role="tab"
                  >Ubuzima</a
                >
              </div>

              <div class="tab-content">
                <div class="tab-pane show active" id="ubuzima-all" role="tabpanel">
                  <div class="row">
                    <UbuzimaAll
                    v-for="(ubuzima,key) in ubuzimas"
                    :key="key"
                    :category="ubuzima.category"
                    :dateCreated="ubuzima.created_at"
                    :title="ubuzima.excerpt"
                    :ubuzimaImg="ubuzima.image"
                    :slug="ubuzima.slug" />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mega-menu-item">
            <a href="/politiki-category">politiki</a>

            <div class="sub-mega-menu">
              <div class="nav flex-column nav-pills" role="tablist">
                <a
                  class="nav-link active"
                  data-toggle="pill"
                  href="#politiki-all"
                  role="tab"
                  >Amakuru ya politiki</a
                >
              </div>

              <div class="tab-content">
                <div class="tab-pane show active" id="politiki-all" role="tabpanel">
                  <div class="row">
                    <PolitikiAll />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <a href="#">Ibikurikira</a>
            <ul class="sub-menu">
              <li><a href="#">Ibidukikije</a></li>
              <li><a href="#">Umuco</a></li>
              <li><a href="#">Twinigure</a></li>
              <li><a href="#">Iyobokamana</a></li>
              <li><a href="/about">Abo Turibo</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import NewsAll from '../components/headers/NewsAll.vue'
import NewsEntertainment from './headers/NewsEntertainment.vue'
import NewsBusiness from './headers/NewsBusiness.vue'
import NewsUbuzima from './headers/NewsUbuzima.vue'
import NewsTravel from './headers/NewsTravel.vue'
import ImyidagaduroAll from './headers/ImyidagaduroAll.vue'
import UbukerarugendoAll from './headers/UbukerarugendoAll.vue'
import BusinessAll from './headers/BusinessAll.vue'
import UbuzimaAll from './headers/UbuzimaAll.vue'
import PolitikiAll from './headers/PolitikiAll.vue'
import axios from 'axios'
export default {
  components: {
    NewsAll,
    NewsEntertainment,
    NewsBusiness,
    NewsUbuzima,
    NewsTravel,
    ImyidagaduroAll,
    UbukerarugendoAll,
    BusinessAll,
    UbuzimaAll,
    PolitikiAll
  },
  data () {
    return {
      newsAll: [],
      businessess: [],
      entertainments: [],
      ubuzimas: [],
      ubukerarugendos: []
    }
  },
  methods: {
    async getAmakuru () {
      const token = localStorage.getItem('token')
      try {
        const response = await axios.get(
          '/api/header-amakuru', {
            headers:
            {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              Authorization: `Bearer ${token}`
            }
          }
        )
        this.newsAll = response.data.newsAll
        this.businessess = response.data.business
        this.entertainments = response.data.imyidagaduro
        this.ubuzimas = response.data.ubuzima
        this.ubukerarugendos = response.data.ubukerarugendo
      } catch (error) {
        if (error.response.data.message === 'Unauthenticated') {
          localStorage.removeItem('token')
          window.location.href = '/login'
        }
      }
    }
  },
  mounted () {
    this.getAmakuru()
  }
}
</script>
